import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { getTranslationFrom, LoadState$2$reflection, LoadState$2 } from "../../Global.js";
import { loadPortations } from "./Api.js";
import { ofArray, tryHead } from "../../fable_modules/fable-library.3.7.20/List.js";
import { PortationKind$reflection, PortationKind } from "./Model.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { uncurry, compare } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrl__get_Value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { Locale_get_FromSelectedLanguage, stackClasses, truncateWithEllipsis, DateTimeExtensions_toDateHHmm, Locale$reflection, loge } from "../../Utils.js";
import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, string_type, int32_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC__toDateTime, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { Size, getMaterialIconBySize, dotsLoading } from "../../ViewUtils.js";
import { getStatusAndBallClasses } from "./Common.js";
import { singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { primary } from "../../Components/Panel/Panel.js";
import { now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import "../../../src/Containers/Portation/PortationBox.scss";


export function SideEffects_loadPortations(clientNr, contractNr, fromDate, toDate, onChangeLoadState) {
    return singleton.Delay(() => {
        onChangeLoadState(new LoadState$2(1));
        return singleton.Bind(loadPortations(clientNr, contractNr, fromDate, toDate), (_arg) => {
            let matchValue, outportation_1, inportation_1, inportation, outportation, inportDate;
            const result = _arg;
            if (result.tag === 0) {
                const portations = result.fields[0];
                onChangeLoadState(new LoadState$2(2, (matchValue = [tryHead(portations.Inportations), tryHead(portations.Outportations)], (matchValue[0] == null) ? ((matchValue[1] == null) ? (new PortationKind(2)) : ((outportation_1 = matchValue[1], new PortationKind(1, outportation_1)))) : ((matchValue[1] == null) ? ((inportation_1 = matchValue[0], new PortationKind(0, inportation_1))) : ((inportation = matchValue[0], (outportation = matchValue[1], (inportDate = defaultArg(inportation.PortingStatusCodeDate, inportation.PortingTime), (compare(defaultArg(outportation.EventTime, outportation.PortingDate), inportDate) >= 0) ? (new PortationKind(1, outportation)) : (new PortationKind(0, inportation))))))))));
                return singleton.Return();
            }
            else {
                onChangeLoadState(new LoadState$2(3, result.fields[0]));
                return singleton.Zero();
            }
        });
    });
}

function getPortationLink(kind) {
    const validatedUrl = ValidatedUrlModule_create(new UrlKind(0, (kind.tag === 1) ? ("/#i/Reports/R25_Outportations?filterQuery=" + kind.fields[0].NumberFrom) : ((kind.tag === 2) ? "" : ("/#i/Reports/R26_Inportations?filterQuery=" + kind.fields[0].NumberFrom))));
    if (validatedUrl.tag === 1) {
        loge(validatedUrl.fields[0]);
        return "";
    }
    else {
        return ValidatedUrl__get_Value(validatedUrl.fields[0]);
    }
}

export class RenderStyle extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TelecomTab", "SimpleOrder"];
    }
}

export function RenderStyle$reflection() {
    return union_type("Containers.Portation.PortationBox.RenderStyle", [], RenderStyle, () => [[], []]);
}

export class PortationBoxProps extends Record {
    constructor(ClientNr, ContractNr, SelectedLanguage, RenderStyle, DateFrom, DateTo) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.SelectedLanguage = SelectedLanguage;
        this.RenderStyle = RenderStyle;
        this.DateFrom = DateFrom;
        this.DateTo = DateTo;
    }
}

export function PortationBoxProps$reflection() {
    return record_type("Containers.Portation.PortationBox.PortationBoxProps", [], PortationBoxProps, () => [["ClientNr", int32_type], ["ContractNr", int32_type], ["SelectedLanguage", string_type], ["RenderStyle", RenderStyle$reflection()], ["DateFrom", UTC$reflection()], ["DateTo", UTC$reflection()]]);
}

export class RenderPortationBoxProps extends Record {
    constructor(LatestPortation, Locale) {
        super();
        this.LatestPortation = LatestPortation;
        this.Locale = Locale;
    }
}

export function RenderPortationBoxProps$reflection() {
    return record_type("Containers.Portation.PortationBox.RenderPortationBoxProps", [], RenderPortationBoxProps, () => [["LatestPortation", LoadState$2$reflection(PortationKind$reflection(), string_type)], ["Locale", Locale$reflection()]]);
}

const renderTelecomTab = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_3;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const matchValue = props.LatestPortation;
    switch (matchValue.tag) {
        case 3: {
            return react.createElement("div", {
                className: "portation__info",
            }, matchValue.fields[0]);
        }
        case 1: {
            return dotsLoading;
        }
        case 2: {
            const portationKind = matchValue.fields[0];
            const patternInput = getStatusAndBallClasses(portationKind);
            const statusBallHtml = patternInput[1];
            const status = patternInput[0];
            const portationLink = getPortationLink(portationKind);
            const headerHtml = (children_3 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Portation")], react.createElement("span", {
                className: "font-weight-bold",
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.Portation",
            }, ...children_3));
            let bodyHtml;
            const children_76 = toList(delay(() => {
                let children_44, children_40, children_42, children_9, children_5, children_7;
                switch (portationKind.tag) {
                    case 1: {
                        const op = portationKind.fields[0];
                        return append(singleton_1((children_44 = [statusBallHtml, (children_40 = [getTranslation("Common.Outportation")], react.createElement("span", {
                            className: "font-weight-bold ml-2",
                            ["data-translation"]: "Common.Outportation",
                        }, ...children_40)), (children_42 = [getMaterialIconBySize("open_in_new", new Size(1))], react.createElement("a", {
                            className: "d-flex ml-2",
                            href: portationLink,
                        }, ...children_42))], react.createElement("div", {
                            className: "d-flex align-items-center mb-2",
                        }, ...children_44))), delay(() => {
                            let children_73, children_71;
                            return singleton_1((children_73 = [(children_71 = toList(delay(() => {
                                let children_50, children_46;
                                return append(singleton_1((children_50 = [(children_46 = [getTranslation("Common.Number")], react.createElement("td", {
                                    className: "plan__header",
                                    ["data-translation"]: "Common.Number",
                                }, ...children_46)), react.createElement("td", {}, op.NumberFrom)], react.createElement("tr", {}, ...children_50))), delay(() => {
                                    let children_56, children_52, children_54;
                                    return append(singleton_1((children_56 = [(children_52 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Date")], react.createElement("td", {
                                        className: "plan__header",
                                        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.Date",
                                    }, ...children_52)), (children_54 = [DateTimeExtensions_toDateHHmm(props.Locale.ILocale, UTC__toDateTime(op.PortingDate))], react.createElement("td", {
                                        className: "no-wrap",
                                    }, ...children_54))], react.createElement("tr", {}, ...children_56))), delay(() => {
                                        let children_62, children_58;
                                        return append(singleton_1((children_62 = [(children_58 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Status")], react.createElement("td", {
                                            className: "plan__header",
                                            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.Status",
                                        }, ...children_58)), react.createElement("td", {}, status)], react.createElement("tr", {}, ...children_62))), delay(() => {
                                            let children_69, children_65, children_67;
                                            const matchValue_2 = op.RecipientText;
                                            if (matchValue_2 != null) {
                                                const recipientText = matchValue_2;
                                                return singleton_1((children_69 = [(children_65 = [getTranslation("Common.ServiceProvider")], react.createElement("td", {
                                                    className: "plan__header",
                                                    ["data-translation"]: "Common.ServiceProvider",
                                                }, ...children_65)), (children_67 = [truncateWithEllipsis(17, recipientText)], react.createElement("td", {
                                                    title: recipientText,
                                                }, ...children_67))], react.createElement("tr", {}, ...children_69)));
                                            }
                                            else {
                                                return singleton_1(react.createElement(react.Fragment, {}));
                                            }
                                        }));
                                    }));
                                }));
                            })), react.createElement("tbody", {}, ...children_71))], react.createElement("table", {
                                className: "portation__plan",
                            }, ...children_73)));
                        }));
                    }
                    case 2: {
                        return singleton_1(react.createElement(react.Fragment, {}));
                    }
                    default: {
                        const ip = portationKind.fields[0];
                        return append(singleton_1((children_9 = [statusBallHtml, (children_5 = [getTranslation("Common.Inportation")], react.createElement("span", {
                            className: "font-weight-bold ml-2",
                            ["data-translation"]: "Common.Inportation",
                        }, ...children_5)), (children_7 = [getMaterialIconBySize("open_in_new", new Size(1))], react.createElement("a", {
                            className: "d-flex ml-2",
                            href: portationLink,
                        }, ...children_7))], react.createElement("div", {
                            className: "d-flex align-items-center mb-2",
                        }, ...children_9))), delay(() => {
                            let children_38, children_36;
                            return singleton_1((children_38 = [(children_36 = toList(delay(() => {
                                let children_15, children_11;
                                return append(singleton_1((children_15 = [(children_11 = [getTranslation("Common.Number")], react.createElement("td", {
                                    className: "plan__header",
                                    ["data-translation"]: "Common.Number",
                                }, ...children_11)), react.createElement("td", {}, ip.NumberFrom)], react.createElement("tr", {}, ...children_15))), delay(() => {
                                    let children_21, children_17, children_19;
                                    return append(singleton_1((children_21 = [(children_17 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Date")], react.createElement("td", {
                                        className: "plan__header",
                                        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.Date",
                                    }, ...children_17)), (children_19 = [DateTimeExtensions_toDateHHmm(props.Locale.ILocale, UTC__toDateTime(ip.PortingTime))], react.createElement("td", {
                                        className: "no-wrap",
                                    }, ...children_19))], react.createElement("tr", {}, ...children_21))), delay(() => {
                                        let children_27, children_23;
                                        return append(singleton_1((children_27 = [(children_23 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Status")], react.createElement("td", {
                                            className: "plan__header",
                                            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.Status",
                                        }, ...children_23)), react.createElement("td", {}, status)], react.createElement("tr", {}, ...children_27))), delay(() => {
                                            let children_34, children_30, children_32;
                                            const matchValue_1 = ip.Donor;
                                            if (matchValue_1 != null) {
                                                const donor = matchValue_1;
                                                return singleton_1((children_34 = [(children_30 = [getTranslation("Common.ServiceProvider")], react.createElement("td", {
                                                    className: "plan__header",
                                                    ["data-translation"]: "Common.ServiceProvider",
                                                }, ...children_30)), (children_32 = [truncateWithEllipsis(17, donor)], react.createElement("td", {
                                                    title: donor,
                                                }, ...children_32))], react.createElement("tr", {}, ...children_34)));
                                            }
                                            else {
                                                return singleton_1(react.createElement(react.Fragment, {}));
                                            }
                                        }));
                                    }));
                                }));
                            })), react.createElement("tbody", {}, ...children_36))], react.createElement("table", {
                                className: "portation__plan mb-2",
                            }, ...children_38)));
                        }));
                    }
                }
            }));
            bodyHtml = react.createElement("div", {
                className: "overview__portation",
            }, ...children_76);
            if (portationKind.tag === 2) {
                return react.createElement(react.Fragment, {});
            }
            else {
                return primary(headerHtml, bodyHtml, void 0);
            }
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderTelecomTab", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Portation\\PortationBox.fs", 235);

const renderSimpleOrder = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_36;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const matchValue = props.LatestPortation;
    switch (matchValue.tag) {
        case 3: {
            return react.createElement("div", {
                className: "portation__info",
            }, matchValue.fields[0]);
        }
        case 1: {
            return dotsLoading;
        }
        case 2: {
            const portationKind = matchValue.fields[0];
            let patternInput;
            switch (portationKind.tag) {
                case 1: {
                    const p_1 = portationKind.fields[0];
                    patternInput = [getTranslation("Common.Outportation"), p_1.NumberFrom, UTC__toDateTime(p_1.PortingDate), p_1.RecipientText];
                    break;
                }
                case 2: {
                    patternInput = ["", "", now(), void 0];
                    break;
                }
                default: {
                    const p = portationKind.fields[0];
                    patternInput = [getTranslation("Common.Inportation"), p.NumberFrom, UTC__toDateTime(p.PortingTime), p.Donor];
                }
            }
            const patternInput_1 = getStatusAndBallClasses(portationKind);
            const portationLink = getPortationLink(portationKind);
            const children_40 = [(children_36 = toList(delay(() => {
                let children_3;
                return append(singleton_1((children_3 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.Portation")], react.createElement("h6", {
                    className: "font-weight-bold",
                }, ...children_3))), delay(() => {
                    let props_10, children_9, props_6, children_7;
                    return append(singleton_1((props_10 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))], (children_9 = [patternInput_1[1], (props_6 = [new HTMLAttr(65, stackClasses(ofArray(["font-weight-bold", "ml-2"])))], react.createElement("div", keyValueList(props_6, 1), patternInput[0])), (children_7 = [getMaterialIconBySize("open_in_new", new Size(1))], react.createElement("a", {
                        className: "d-flex ml-2",
                        href: portationLink,
                    }, ...children_7))], react.createElement("div", keyValueList(props_10, 1), ...children_9)))), delay(() => {
                        let children_15, children_11, arg;
                        return append(singleton_1((children_15 = [(children_11 = [(arg = getTranslation("Common.Number"), toText(printf("%s: "))(arg))], react.createElement("span", {
                            ["data-translation"]: "Common.Number",
                        }, ...children_11)), react.createElement("span", {}, patternInput[1])], react.createElement("div", {}, ...children_15))), delay(() => {
                            let children_21, children_17, arg_1, children_19;
                            return append(singleton_1((children_21 = [(children_17 = [(arg_1 = getTranslation("Common.Date"), toText(printf("%s: "))(arg_1))], react.createElement("span", {
                                ["data-translation"]: "Common.Date",
                            }, ...children_17)), (children_19 = [DateTimeExtensions_toDateHHmm(props.Locale.ILocale, patternInput[2])], react.createElement("span", {}, ...children_19))], react.createElement("div", {}, ...children_21))), delay(() => {
                                let children_27, children_23, arg_2;
                                return append(singleton_1((children_27 = [(children_23 = [(arg_2 = getTranslation("Common.Status"), toText(printf("%s: "))(arg_2))], react.createElement("span", {
                                    ["data-translation"]: "Common.Status",
                                }, ...children_23)), react.createElement("span", {}, patternInput_1[0])], react.createElement("div", {}, ...children_27))), delay(() => {
                                    let children_34, children_30, arg_3, children_32;
                                    const matchValue_1 = patternInput[3];
                                    if (matchValue_1 != null) {
                                        const serviceProvider = matchValue_1;
                                        return singleton_1((children_34 = [(children_30 = [(arg_3 = getTranslation("Common.ServiceProvider"), toText(printf("%s: "))(arg_3))], react.createElement("span", {
                                            ["data-translation"]: "Common.ServiceProvider",
                                        }, ...children_30)), (children_32 = [truncateWithEllipsis(14, serviceProvider)], react.createElement("span", {
                                            title: serviceProvider,
                                        }, ...children_32))], react.createElement("div", {}, ...children_34)));
                                    }
                                    else {
                                        return singleton_1(react.createElement(react.Fragment, {}));
                                    }
                                }));
                            }));
                        }));
                    }));
                }));
            })), react.createElement("div", {
                className: "mb-3",
            }, ...children_36)), react.createElement("div", {
                className: "container__actions",
            })];
            return react.createElement("div", {}, ...children_40);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderSimpleOrder", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Portation\\PortationBox.fs", 305);

function isWithinAllowedTimespan(dateFrom, dateTo, portationDateOpt) {
    if (portationDateOpt != null) {
        const portationDate = portationDateOpt;
        if (compare(portationDate, dateFrom) >= 0) {
            return compare(portationDate, dateTo) <= 0;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export const renderPortationBox = FunctionComponent_Of_Z5A158BBF((props) => {
    let matchValue, latestPortation;
    const latestPortationState = react.useState(new LoadState$2(0));
    const locale = Locale_get_FromSelectedLanguage()(props.SelectedLanguage);
    react.useEffect(() => {
        startImmediate(SideEffects_loadPortations(props.ClientNr, props.ContractNr, props.DateFrom, props.DateTo, (arg) => {
            latestPortationState[1](arg);
        }));
    }, [props.ClientNr, props.ContractNr]);
    const matchValue_1 = [isWithinAllowedTimespan(props.DateFrom, props.DateTo, (matchValue = (latestPortationState[0]), (matchValue.tag === 2) ? ((latestPortation = matchValue.fields[0], (latestPortation.tag === 1) ? latestPortation.fields[0].PortingDate : ((latestPortation.tag === 2) ? (void 0) : latestPortation.fields[0].PortingTime))) : (void 0))), props.RenderStyle];
    if (matchValue_1[0]) {
        if (matchValue_1[1].tag === 1) {
            const children_2 = [renderSimpleOrder(new RenderPortationBoxProps(latestPortationState[0], locale))];
            return react.createElement("div", {
                className: "portation-box",
            }, ...children_2);
        }
        else {
            const children = [renderTelecomTab(new RenderPortationBoxProps(latestPortationState[0], locale))];
            return react.createElement("div", {
                className: "portation-box",
            }, ...children);
        }
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}, void 0, uncurry(2, void 0), void 0, "renderPortationBox", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Portation\\PortationBox.fs", 355);

